import { render, staticRenderFns } from "./Tarefas.vue?vue&type=template&id=62e45155&scoped=true"
import script from "./Tarefas.vue?vue&type=script&lang=js"
export * from "./Tarefas.vue?vue&type=script&lang=js"
import style0 from "./Tarefas.vue?vue&type=style&index=0&id=62e45155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e45155",
  null
  
)

export default component.exports